import { DetailsOpenStatusByTravelerIdByPartsName } from '../../interface/checkin-passenger-input';

/**
 * CheckinPassengerInput model details
 */
export interface CheckinPassengerInputStateDetails {}

/**
 * CheckinPassengerInput store state
 */
export interface CheckinPassengerInputState extends CheckinPassengerInputStateDetails {
  model: DetailsOpenStatusByTravelerIdByPartsName | null;
}

/**
 * Name of the CheckinPassengerInput Store
 */
export const CHECKIN_PASSENGER_INPUT_STORE_NAME = 'checkinPassengerInput';

/**
 * CheckinPassengerInput Store Interface
 */
export interface CheckinPassengerInputStore {
  /** CheckinPassengerInput state */
  [CHECKIN_PASSENGER_INPUT_STORE_NAME]: CheckinPassengerInputState;
}
